<nav class="sidenav shadow-right sidenav-light">
  <div class="sidenav-menu">
    <div class="nav accordion" id="accordionSidenav">
      @for (child of menuService.menuList$ | async; track child; let i = $index) {
        @if ((!child.dynamic || (child.dynamic && showDynamic)) && !child.direct) {
          @if (!child.submenu) {
            <a class="nav-link mt-1 ml-1 mr-1 parent-node" [ngClass]="getItemCssClasses(child)" [routerLink]="child.page">
              {{ child.translate | translate }}
            </a>
          }
        }
        @if (child.direct) {
          <a class="nav-link mt-1 ml-1 mr-1 parent-node" [ngClass]="getItemCssClasses(child)"  [routerLink]="child.page"
          (click)="redirect(child.page)">{{child.translate | translate }}</a>
        }
        @if (child.submenu && (!child.dynamic || (child.dynamic && showDynamic)) && !child.direct) {
          <a class="nav-link mt-1 ml-1 mr-1 collapsed parent-node" href="javascript:void(0);" data-toggle="collapse" [attr.data-target]="'#collapseComponents' + i" aria-expanded="false"
            [ngClass]="getItemCssClasses(child)" aria-controls="collapseComponents1">
            {{ child.translate | translate  }}
            <div class="sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
          </a>
        }
        @if (child.submenu) {
          <div class="collapse" id="collapseComponents{{i}}" [ngClass]="getItemCssClasses(child)" data-parent="#accordionSidenav">
            @for (subchild of child.submenu; track subchild) {
              <nav class="sidenav-menu-nested nav">
                @if (subchild.modalOpen) {
                  @if (!subchild.showOnlyWhenActive || isCurrentPageActive(subchild.page)) {
                    <a class="nav-link child-node" style="cursor: pointer;" [ngClass]="getItemCssClasses(subchild)" (click)="openModal(subchild.page)">{{subchild.translate | translate }}</a>
                  }
                }
                @if (!subchild.modalOpen) {
                  @if (!subchild.showOnlyWhenActive || isCurrentPageActive(subchild.page)) {
                    <a class="nav-link child-node" [ngClass]="getItemCssClasses(subchild)" [routerLink]="subchild.page" (click)="redirect(subchild.page)">{{subchild.translate | translate }}</a>
                  }
                }
              </nav>
            }
          </div>
        }
      }
    </div>
  </div>
</nav>
